import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  useTheme,
  alpha,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
} from '@mui/material';
import {
  Add as AddIcon,
  Visibility as ViewIcon,
  Edit as EditIcon,
  ExpandMore as ExpandMoreIcon,
  Assignment as AssignmentIcon,
  CheckCircle as CheckIcon,
  Schedule as ScheduleIcon,
} from '@mui/icons-material';

const PartesDiarios = () => {
  const theme = useTheme();
  const [openDialog, setOpenDialog] = useState(false);

  const partesData = [
    {
      id: 1,
      fecha: '03/02/2026',
      locacion: 'Pozo XY-123',
      supervisor: 'Juan Rodríguez',
      estado: 'Aprobado',
      personal: 12,
      horas: 144,
      novedades: 'Operación normal. Se completó tramo 2 de perforación.',
      actividades: ['Perforación 1500-1650 mts', 'Control de lodos', 'Registro de parámetros'],
    },
    {
      id: 2,
      fecha: '02/02/2026',
      locacion: 'Pozo AB-456',
      supervisor: 'Pedro García',
      estado: 'Pendiente',
      personal: 8,
      horas: 96,
      novedades: 'Retraso por condiciones climáticas. Viento fuerte AM.',
      actividades: ['Stand by clima (4hs)', 'Workover preparación', 'Armado de torre'],
    },
    {
      id: 3,
      fecha: '01/02/2026',
      locacion: 'Pozo XY-123',
      supervisor: 'Juan Rodríguez',
      estado: 'Aprobado',
      personal: 12,
      horas: 144,
      novedades: 'Inicio de tramo 2. Sin novedades.',
      actividades: ['Perforación 1350-1500 mts', 'Cambio de broca', 'Cementación'],
    },
  ];

  return (
    <Box className="fade-in">
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
        <Box>
          <Typography variant="h4" fontWeight={700} color="primary">
            Partes Diarios
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Reportes diarios de campo
          </Typography>
        </Box>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpenDialog(true)}>
          Nuevo Parte
        </Button>
      </Box>

      {/* Resumen */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={6} sm={3}>
          <Card>
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography variant="h4" fontWeight={700} color="primary">45</Typography>
              <Typography variant="body2" color="text.secondary">Partes Feb 2026</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Card>
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography variant="h4" fontWeight={700} color="success.main">42</Typography>
              <Typography variant="body2" color="text.secondary">Aprobados</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Card>
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography variant="h4" fontWeight={700} color="warning.main">3</Typography>
              <Typography variant="body2" color="text.secondary">Pendientes</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Card>
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography variant="h4" fontWeight={700} color="info.main">5,400</Typography>
              <Typography variant="body2" color="text.secondary">Horas Totales</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Lista de Partes */}
      {partesData.map((parte) => (
        <Accordion key={parte.id} sx={{ mb: 2, '&:before': { display: 'none' }, borderRadius: 2 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%', pr: 2 }}>
              <AssignmentIcon color="primary" />
              <Box sx={{ flex: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="body1" fontWeight={600}>{parte.locacion}</Typography>
                  <Chip
                    icon={parte.estado === 'Aprobado' ? <CheckIcon /> : <ScheduleIcon />}
                    label={parte.estado}
                    size="small"
                    color={parte.estado === 'Aprobado' ? 'success' : 'warning'}
                  />
                </Box>
                <Typography variant="caption" color="text.secondary">
                  {parte.fecha} • Supervisor: {parte.supervisor}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: 3 }}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="body2" fontWeight={600}>{parte.personal}</Typography>
                  <Typography variant="caption" color="text.secondary">Personal</Typography>
                </Box>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="body2" fontWeight={600}>{parte.horas}hs</Typography>
                  <Typography variant="caption" color="text.secondary">Horas</Typography>
                </Box>
              </Box>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                  Actividades Realizadas
                </Typography>
                <Box component="ul" sx={{ m: 0, pl: 2 }}>
                  {parte.actividades.map((act, index) => (
                    <Typography component="li" variant="body2" key={index}>{act}</Typography>
                  ))}
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                  Novedades
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {parte.novedades}
                </Typography>
              </Grid>
            </Grid>
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
              <IconButton size="small"><ViewIcon /></IconButton>
              <IconButton size="small"><EditIcon /></IconButton>
              {parte.estado === 'Pendiente' && (
                <Button size="small" variant="contained" color="success">
                  Aprobar
                </Button>
              )}
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}

      {/* Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>Nuevo Parte Diario</DialogTitle>
        <DialogContent>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="Fecha" type="date" InputLabelProps={{ shrink: true }} />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Locación</InputLabel>
                <Select label="Locación">
                  <MenuItem value="1">Pozo XY-123</MenuItem>
                  <MenuItem value="2">Pozo AB-456</MenuItem>
                  <MenuItem value="3">Workover MZ-789</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="Personal en Campo" type="number" />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="Horas Totales" type="number" />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth label="Actividades Realizadas" multiline rows={3} placeholder="Detallar las actividades principales del día..." />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth label="Novedades / Observaciones" multiline rows={2} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth label="Condiciones Climáticas" />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button onClick={() => setOpenDialog(false)}>Cancelar</Button>
          <Button variant="contained" onClick={() => setOpenDialog(false)}>Guardar Parte</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PartesDiarios;
